import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';

import { cn } from '@utils/cn';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
  hasIndicator?: boolean;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { className, children, hasIndicator, type = 'button', ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        'relative grid h-9 w-9 shrink-0 place-items-center rounded-[9px] border border-line bg-transparent text-t2 transition-colors',
        'hover:border-line-hi hover:bg-surface-2 hover:text-t1 focus:outline-none focus-visible:shadow-[0_0_0_3px_var(--gold-dim)]',
        className,
      )}
      {...rest}
    >
      {children}
      {hasIndicator ? (
        <span className="absolute right-[5px] top-[5px] h-2 w-2 rounded-full border-2 border-surface bg-accent-red" />
      ) : null}
    </button>
  );
});

export default IconButton;
